<template>
  <b-container>
      <b-row class="mx-auto simple-text">
        <b-col cols="12">
          <label for="answer" class="mb-3 title-question" v-html="question.title" style="text-align: justify;padding-right: 0.9rem;"></label>
        </b-col>
        <b-col sm="12" md="8" lg="8" xl="8" class="mx-auto"> 
          <textarea name="answer" id="answer" v-model="question.value" rows="3" class="form-control form-control-lg" autofocus no-resize></textarea>
        </b-col>
      </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    };
  },
  watch: {
    question: function (newVal, oldVal) { // 
      this.changeStep();
    }
  },
  mounted () {
    /* next and preview always is same for type Check and Text question */
    this.changeStep();
  },
  methods: {
    changeStep () {
      /* send object and with value, next Question id and previus, and set value in json reactive */ 
      this.$emit('change-step', {
        nextQuestionId: this.question.next_question_id, 
        previusQuestionId: this.question.previus_question_id
      });
    },
  }
};
</script>

<style lang="css">
  label{
    font-size: 20px;
  }
  textarea
  {
    resize: none;
  }
  @media only screen and (orientation: portrait) and (max-width: 475px)  {
    .simple-text label {
      margin-bottom: 1rem;
      font-size: 16px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/surveys/v2/components/SimpleText.vue